const globalCfg = window.VtxPublicServiceAddress || {};

export default {
    // ztree文件地址
    ztreeServer: globalCfg.ztreeServer ? globalCfg.ztreeServer : '//vortexplugin.cloudhw.cn/ztree',
};
